import { BreadcrumbsProps } from '@mui/material';
import { Icon } from '../Icon';

export const getBreadCrumbClassName = (): string => {
  return ['breadcrumb '].join(' ');
};

export const getBreadCrumbElementClass = (
  className?: string,
  isLastItem?: boolean
): string => {
  return [
    'line-clamp-1 cursor-pointer rounded border border-transparent text-sm font-medium leading-tight hover:bg-Primary/Other/Hover focus:outline-none focus-visible:border-Primary/Border active:bg-Primary/Pressed active:text-Text/Darkbackground/Secondary truncate',
    isLastItem && 'text-Text/LightBackground/Primary',
    className,
  ].join(' ');
};

export const getBreadCrumbProps = (): BreadcrumbsProps => {
  return {
    separator: (
      <button className={getBreadCrumbElementClass('h-5 px-[2px]')}>
        <Icon width={16} height={16} iconName="chevron-right" />
      </button>
    ),
    maxItems: 4,
    itemsAfterCollapse: 2,
    itemsBeforeCollapse: 2,
    sx: {
      '& .MuiBreadcrumbs-ol': {
        display: 'flex',
        flexWrap: 'nowrap',
        gap: '2px',
        listStyleType: 'none',
        margin: '0',
        padding: '0',
      },
      '& .MuiBreadcrumbs-separator': {
        margin: '0',
      },
      '& .MuiButtonBase-root': {
        padding: '0',
        margin: '0',
        border: '1px solid transparent',
        borderRadius: '4px',
        ':focus-visible': {
          border: '1px solid #009FE4',
        },
        ':focus': {
          background: 'transparent',
        },
        '& .MuiTouchRipple-root': {
          display: 'none',
        },
      },
      ' .MuiBreadcrumbs-li': {
        minWidth: '20px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
    },
    slotProps: {
      collapsedIcon: {
        className: getBreadCrumbElementClass('h-[22px] px-1'),
        width: 22,
        height: 22,
      },
    },
  };
};
